// src/models/page.ts
import type { Hero, RawHero } from '@/models/hero'
import { normalizeHero } from '@/models/hero'
import { normalizeTranslations, type TranslationsMap } from '@/models/translations'
import type { AcfFlexItem } from '@/utils/components'

export type RawWpTitle = {
  rendered: string
}

export type RawPageAcf = {
  hero?: RawHero
  excerpt?: unknown
  meta?: unknown
  components?: AcfFlexItem[] | false
  settings?: Record<string, unknown>
}

export type RawPage = {
  id: number
  type: string
  parent?: number
  slug: string
  relative_url?: string
  menu_order?: number
  date?: string
  modified?: string
  title: RawWpTitle
  excerpt?: RawWpTitle
  featured_media?: number
  meta?: unknown
  seo?: unknown
  acf?: RawPageAcf
  translations?: unknown
}

export type PageModel = {
  id: number
  type: string
  parent?: number
  slug: string
  relativeUrl?: string
  order?: number
  date?: string
  modified?: string
  title: string
  media?: number
  translations?: TranslationsMap
  hero?: Hero
  excerpt?: RawPageAcf['excerpt']
  meta?: RawPageAcf['meta']
  seo?: unknown
  components?: AcfFlexItem[] | false
  settings?: RawPageAcf['settings']
}

const page = (p: RawPage): PageModel => ({
  id: p.id,
  type: p.type,
  parent: p.parent,
  slug: p.slug,
  relativeUrl: p.relative_url,
  order: p.menu_order,
  date: p.date,
  modified: p.modified,
  title: p.title.rendered,
  media: p.featured_media || undefined,
  translations: normalizeTranslations(p.translations),
  hero: normalizeHero(p.acf?.hero),
  excerpt: p.acf?.excerpt ?? p.excerpt,
  meta: p.acf?.meta ?? p.meta,
  seo: p.seo,
  components: p.acf?.components,
  settings: p.acf?.settings,
})

export default page
